
import React from "react";
import { Card } from "@/components/ui/card";
import { Message } from "@/types/message";
import { useSellerResponseSection } from "./hooks/useSellerResponseSection";
import SellerResponseContent from "./seller-response/SellerResponseContent";

interface SellerResponseSectionProps {
  onPasteSellerResponse: (content: string) => void;
  isPasting: boolean;
  isProcessingAI: boolean;
  hasMessages: boolean;
  lastAIMessage?: Message | null;
  isFlightClaim?: boolean;
}

const SellerResponseSection = ({
  onPasteSellerResponse,
  isPasting,
  isProcessingAI,
  hasMessages,
  lastAIMessage,
  isFlightClaim = false
}: SellerResponseSectionProps) => {
  const { isResponseInProgress } = useSellerResponseSection({
    isPasting,
    isProcessingAI,
    hasMessages,
    lastAIMessage
  });

  return (
    <Card>
      <SellerResponseContent
        onPasteSellerResponse={onPasteSellerResponse}
        isGenerating={isResponseInProgress}
        hasMessages={hasMessages}
        lastAIMessage={lastAIMessage}
        isFlightClaim={isFlightClaim}
      />
    </Card>
  );
};

export default SellerResponseSection;
